import { render, staticRenderFns } from "./BankPackagesShow.vue?vue&type=template&id=22828302&scoped=true&"
import script from "./BankPackagesShow.vue?vue&type=script&lang=js&"
export * from "./BankPackagesShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22828302",
  null
  
)

export default component.exports